import { ViewItem } from '@/components/goods/Cases.vue';
import { CLOUD_URL_MAT_SET } from '@/constants/cloud-url';
import { IncomingEntity } from '@/models/entities/incoming-entity.model';
import { TireSign } from '@/models/entities/tyre-sign.model';
import { ContactType } from '@/models/store/contacts/contact-type.model';
import { IAdditionItem } from '@/models/store/mats-cases/additional-item.model';
import { MatColor } from '@/models/store/mats-cases/mat-color.model';
import { MatFigure } from '@/models/store/mats-cases/mat-figure.model';
import { IMat } from '@/models/store/mats-cases/mat.model';
import { IHelperEntityTire } from '@/models/store/tires/helper-entity-tire.model';
import { store } from '@/store';
import { isEqual } from 'lodash';

const currentMatFigure = (matFigure: MatFigure): string => {
    switch (matFigure) {
        case 'Premium':
            return matFigure.toLowerCase();
        case 'Standart':
            return matFigure.toLowerCase();
        case 'Ромб':
            return 'rhombus';
        case 'Шестиугольник':
            return 'hexagon';
    }
};

const curMatColor = (color: MatColor): string => {
    switch (color) {
        case 'Бежевый':
            return 'beige';
        case 'Графит':
            return 'graphite';
        case 'Серый':
            return 'grey';
        case 'Черный':
            return 'black';
        case 'Коричневый':
            return 'brown';
        case 'Красный':
            return 'red';
        default:
            return '';
    }
};

export const service = {
    returnHref(type: ContactType, contact: string): string {
        let result = '';
        switch (true) {
            case isEqual(type, 'phone'):
                result = `tel:+375${contact}`;
                break;

            case isEqual(type, 'viber'):
                result = `viber://chat/?number=%2` + `+375${contact}`;
                break;

            case isEqual(type, 'telegram'):
                result = ``;
                break;

            case isEqual(type, 'instagram'):
                result = ``;
                break;

            case isEqual(type, 'email'):
                result = '';
                break;

            case isEqual(type, 'youtube'):
                result = '';
                break;
        }

        return result;
    },

    mainContainerHeight: (path: string): string => {
        let result = '';
        switch (true) {
            case isEqual(path, '/'):
                result = '1170px';
                break;

            case isEqual(path, '/centering-rings'):
                result = '1902px';
                break;
        }

        return result;
    },

    handleHelperEssences(helperEssences: IHelperEntityTire[], tireSign: TireSign): string[] {
        const result: string[] = [];
        const resultForSet: string[] = helperEssences.reduce(
            (previous: string[], item: IHelperEntityTire) => {
                let indexArray!: number;
                switch (tireSign) {
                    case 'width':
                        indexArray = 0;
                        break;

                    case 'height':
                        indexArray = 1;
                        break;

                    case 'diameter':
                        indexArray = 2;
                        break;
                }

                previous.push(item.name.split('/')[indexArray]);
                return previous;
            },
            [],
        );

        for (const elem of new Set(resultForSet)) result.push(elem);

        return result.sort();
    },

    capitalize: (str: string): string => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },

    matSetUrl: (currentMatId: string, mats: IMat[]): string => {
        const curMat: IMat | undefined = mats.find((item: IMat) => isEqual(item._id, currentMatId));

        return curMat
            ? CLOUD_URL_MAT_SET +
                  `${isEqual(curMat.matType, 'ворс') ? 'vors' : 'eva'}` +
                  `_${currentMatFigure(curMat.matFigure as MatFigure)}` +
                  `_${curMatColor(curMat.color as MatColor)}` +
                  '.jpg'
            : '';
    },

    totalOrderPrice: (data: IncomingEntity, countGoods: string): string => {
        countGoods = countGoods ? countGoods : '1';
        const pricesArr: string[] = [];
        const currentSalePrice: string = store.getters.getActiveEntitySaleIds.includes(
            (data as IncomingEntity)._id,
        )
            ? (
                  Number((data as IncomingEntity).salePrice) -
                  Number((data as IncomingEntity).saleValue) *
                      Number((data as IncomingEntity).salePrice)
              ).toFixed(0)
            : (data as IncomingEntity)?.salePrice;

        pricesArr.push((Number(currentSalePrice) * Number(countGoods)).toFixed(1));
        if (data.additions?.length)
            data.additions.forEach((item: IAdditionItem) => {
                if (item.checkbox) {
                    const count: number =
                        isEqual(item.additionalType, 'label') && data.labelCount
                            ? data.labelCount
                            : isEqual(item.additionalType, 'fastener') && data.fastenerCount
                              ? data.fastenerCount
                              : isEqual(item.additionalType, 'thrustBearing') &&
                                  data.thrustBearingCount
                                ? data.thrustBearingCount
                                : 1;
                    pricesArr.push((Number(item.salePrice) * count).toFixed(1));
                }
            });

        return pricesArr.reduce((prev: string, item: string) => {
            return (Number(prev) + Number(item)).toFixed(1);
        }, '');
    },

    createMatBaseViews: (storeUrl: string[]): ViewItem[] => {
        return storeUrl.map((item: string) => ({ src: CLOUD_URL_MAT_SET + item }));
    },
};
